var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpeakerIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3315 15.5019L6.16373 15.4996C3.58549 15.4996 1.49512 13.4081 1.49512 10.8286V9.665C1.49512 7.08559 3.58549 4.99522 6.1649 4.99522H14.3326L18.8518 1.90693C20.4018 0.848327 22.5039 1.95829 22.5039 3.83507V16.6644C22.5039 18.5412 20.4007 19.6512 18.8518 18.5914L14.3315 15.5019Z",
    stroke: "#0B1029",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3336 4.99805V15.5024",
    stroke: "#0B1029",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 15.502L6.78067 20.0048C7.0993 20.8102 7.87196 21.3377 8.72982 21.3377V21.3377C10.2133 21.3377 11.2287 19.8274 10.6813 18.435L9.52698 15.502",
    stroke: "#0B1029",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeakerIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SpeakerIcon.cdb8b5b6.svg";
export { ForwardRef as ReactComponent };